import { User } from ".";
import { fetchApi } from "../../utils/api";
import { Provider } from "../../utils/types";

export const isUserLoggedIn = async (): Promise<User | null> => {
  await fetchApi("/sanctum/csrf-cookie");

  const res = await fetchApi("/auth/is-logged-in");

  if (!res.ok) return null;

  const response = await res.json();

  return response.data;
};

export const logOut = async () => {
  await fetchApi("/logout");
};

export const getLoginUrl = async (
  searchParams: string,
  provider: Provider
): Promise<string> => {
  const response = await fetchApi(`/login/${provider}?${searchParams}`);

  if (!response.ok) {
    throw new Error("Failed to fetch the redirect url!");
  }

  const { url } = await response.json();

  return url;
};
